<template>
    <rkm-row>
        <rkm-col cols="6">
            Data de criação: {{ this.data.model.alteracao.dataCadastro }}
        </rkm-col>
        <rkm-col cols="6">
            Usuário de criação: {{ this.data.model.alteracao.usuarioCadastro }}
        </rkm-col>
        <rkm-col cols="6">
            Data da última alteração: {{ this.data.model.alteracao.dataAlteracao }}
        </rkm-col>
        <rkm-col cols="6">
            Usuário da última alteração: {{ this.data.model.alteracao.usuarioAlteracao }}
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    data: () => ({
        form: null,
        model: {
            usuario: null,
            unidadeId: null,
            infraestruturaId: null
        },
    }),
    methods: {},
    props: {
        data: { type: Object, required: false, },
    }
}
</script>